// assets/megamenu.js
const initMegamenu = () => {
  console.log("Megamenu: initMegamenu called");
  
  let retries = 0;
  
  const startInit = () => {
    const headerComponent = document.querySelector('header-component');
    if (!headerComponent) {
      if (retries < 15) {
        retries++;
        console.log(`Megamenu: header-component not found, retrying in 100ms (attempt ${retries})`);
        setTimeout(startInit, 100);
      } else {
        console.error("Megamenu: header-component not found after 15 attempts");
      }
      return;
    }
    
    console.log("Megamenu: header-component successfully found in DOM");

    const getMenuType = () => {
      const type = headerComponent.getAttribute('data-menu-type-desktop');
      console.log("Megamenu: data-menu-type-desktop =", type);
      return type;
    };

    let activePanel = null;
    let activeLink = null;
    let scheduledLink = null;
    let openTimeout = null;
    let closeTimeout = null;

    // Map panels to header links dynamically based on their data-megamenu-title setting
    const mapPanels = () => {
      const panels = document.querySelectorAll('.megamenu-panel');
      console.log("Megamenu: Mapping panels. Count =", panels.length);
      panels.forEach(panel => {
        const titleAttr = panel.getAttribute('data-megamenu-title');
        if (!titleAttr) return;
        const title = titleAttr.trim().toLowerCase();
        
        const links = document.querySelectorAll('.menu-list__link');
        links.forEach(link => {
          const linkTitleEl = link.querySelector('.menu-list__link-title');
          const linkTitle = (linkTitleEl ? linkTitleEl.firstChild.textContent : link.textContent).trim().toLowerCase();
          
          if (linkTitle === title) {
            const panelId = panel.id.replace('megamenu-', '');
            link.setAttribute('data-megamenu-id', panelId);
            console.log(`Megamenu: Dynamically mapped link "${linkTitle}" to panel "${panelId}"`);
          }
        });
      });
    };

    mapPanels();

    const openPanel = (link, panel) => {
      const menuType = getMenuType();
      console.log("Megamenu: openPanel called for:", link, "with panel:", panel);
      if (menuType !== 'mega' && menuType !== 'megamenu' && menuType !== 'dropdown') {
        console.warn("Megamenu: Ignored openPanel because menuType is not mega, megamenu or dropdown");
        return;
      }
      if (window.innerWidth < 990) {
        console.warn("Megamenu: Ignored openPanel because window width < 990px");
        return;
      }

      clearTimeout(closeTimeout);

      if (activePanel === panel) {
        return;
      }

      if (scheduledLink === link) {
        return;
      }

      clearTimeout(openTimeout);
      scheduledLink = link;

      console.log("Megamenu: Scheduling open in 150ms");
      openTimeout = setTimeout(() => {
        scheduledLink = null;
        // Close other panels immediately
        if (activePanel && activePanel !== panel) {
          console.log("Megamenu: Closing active panel:", activePanel);
          activePanel.classList.remove('is-active');
          activePanel.hidden = true;
          if (activeLink) activeLink.setAttribute('aria-expanded', 'false');
        }
        
        console.log("Megamenu: Activating panel:", panel);
        panel.hidden = false;
        // force reflow to ensure CSS transition works
        void panel.offsetWidth; 
        
        panel.classList.add('is-active');
        link.setAttribute('aria-expanded', 'true');
        
        activePanel = panel;
        activeLink = link;
      }, 150);
    };

    const closePanel = (link, panel) => {
      console.log("Megamenu: closePanel called for panel:", panel);
      if (scheduledLink === link) {
        clearTimeout(openTimeout);
        scheduledLink = null;
      }

      clearTimeout(closeTimeout);
      
      closeTimeout = setTimeout(() => {
        console.log("Megamenu: Deactivating panel:", panel);
        panel.classList.remove('is-active');
        link.setAttribute('aria-expanded', 'false');
        
        setTimeout(() => {
          if (!panel.classList.contains('is-active')) {
            panel.hidden = true;
            if (activePanel === panel) {
              activePanel = null;
              activeLink = null;
            }
          }
        }, 300); // Wait for transition
      }, 150);
    };

    // Remove any previously delegated event listeners to avoid duplicates on re-init
    document.removeEventListener('mouseover', handleMouseOver);
    document.removeEventListener('mouseout', handleMouseOut);
    document.removeEventListener('keydown', handleKeyDown);

    // Bind clean new delegated listeners
    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('mouseout', handleMouseOut);
    document.addEventListener('keydown', handleKeyDown);

    function handleMouseOver(e) {
      const link = e.target.closest('a[data-megamenu-id]');
      const panel = e.target.closest('.megamenu-panel');

      if (link) {
        const id = link.getAttribute('data-megamenu-id');
        console.log("Megamenu: mouseover detected on link with megamenu id =", id);
        const targetPanel = document.getElementById(`megamenu-${id}`);
        if (targetPanel) {
          openPanel(link, targetPanel);
        } else {
          console.error("Megamenu: Target panel was not found for id =", id);
        }
      } else if (panel) {
        console.log("Megamenu: mouseover detected on panel:", panel);
        const linkId = panel.id.replace('megamenu-', '');
        const targetLink = document.querySelector(`a[data-megamenu-id="${linkId}"]`);
        if (targetLink) {
          openPanel(targetLink, panel);
        }
      }
    }

    function handleMouseOut(e) {
      const link = e.target.closest('a[data-megamenu-id]');
      const panel = e.target.closest('.megamenu-panel');

      const relatedLink = e.relatedTarget ? e.relatedTarget.closest('a[data-megamenu-id]') : null;
      const relatedPanel = e.relatedTarget ? e.relatedTarget.closest('.megamenu-panel') : null;

      if (link) {
        if (relatedLink === link) return; // Still on the same link
        const id = link.getAttribute('data-megamenu-id');
        const targetPanel = document.getElementById(`megamenu-${id}`);
        if (targetPanel && relatedPanel === targetPanel) return; // Moving from link to its panel
        if (targetPanel) {
          closePanel(link, targetPanel);
        }
      } else if (panel) {
        if (relatedPanel === panel) return; // Still on the same panel
        const linkId = panel.id.replace('megamenu-', '');
        const targetLink = document.querySelector(`a[data-megamenu-id="${linkId}"]`);
        if (targetLink && relatedLink === targetLink) return; // Moving from panel to its link
        if (targetLink) {
          closePanel(targetLink, panel);
        }
      }
    }

    function handleKeyDown(e) {
      if (e.key === 'Escape') {
        const activeElement = document.activeElement;
        const link = activeElement ? activeElement.closest('a[data-megamenu-id]') : null;
        const panel = activeElement ? activeElement.closest('.megamenu-panel') : null;

        if (link && activePanel) {
          const id = link.getAttribute('data-megamenu-id');
          const targetPanel = document.getElementById(`megamenu-${id}`);
          if (targetPanel && targetPanel.classList.contains('is-active')) {
            closePanel(link, targetPanel);
            link.focus();
          }
        } else if (panel) {
          const linkId = panel.id.replace('megamenu-', '');
          const targetLink = document.querySelector(`a[data-megamenu-id="${linkId}"]`);
          if (targetLink) {
            closePanel(targetLink, panel);
            targetLink.focus();
          }
        }
      }
    }

  };

  startInit();
};

// Bind initial execution
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMegamenu);
} else {
  initMegamenu();
}

// Bind shopify theme editor section reload execution
document.addEventListener('shopify:section:load', (event) => {
  console.log("Megamenu: shopify:section:load detected on target:", event.target);
  initMegamenu();
});

